import React from 'react';
import Meta from '@components/common/Meta';
import Title from '@components/common/Title';
export default function TermsConditionsMeta() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    title: "Terms and Conditions"
  }), /*#__PURE__*/React.createElement(Meta, {
    name: "description",
    content: "Read the Chicken Kickers Terms and Conditions governing the use of our website, orders, delivery, and services."
  }));
}
;